import { Module } from "vuex";

import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";
import { RootState } from "@/interfaces/store/root-state";
import { ServiceState } from "@/interfaces/store/service-state";

/**
 * サービス・ストア
 */
export const serviceModule: Module<ServiceState, RootState> = {
  namespaced: true,
  state: {
    serviceCategories: [],
  },
  mutations: {
    setServiceCategories: (
      state: ServiceState,
      serviceCategories: ServiceCategoryInterface[]
    ): void => {
      state.serviceCategories = serviceCategories;
    },
  },
  getters: {},
  actions: {},
  modules: {},
};
